import React from "react"
import Slider from "react-slick"
import '../styles/components/testimonial-slider.scss'

import background from '../images/TestimonialSlider/lo-fly-dirt/testimonial_bg.jpg'
import background2 from '../images/TestimonialSlider/lo-fly-dirt/bg-4.jpg'
import AG from '../images/TestimonialSlider/lo-fly-dirt/ag-got-beats.png'
import Billy from '../images/TestimonialSlider/lo-fly-dirt/billy-vintage-blass.png'
import Damon from '../images/TestimonialSlider/lo-fly-dirt/damon-flores.png'
import Daniel from '../images/TestimonialSlider/lo-fly-dirt/daniel-steele.png'
import David from '../images/TestimonialSlider/lo-fly-dirt/david-lopez.png'
import Crista from '../images/TestimonialSlider/lo-fly-dirt/dj-cristagurl.png'
import Donell from '../images/TestimonialSlider/lo-fly-dirt/donell-mcgary.png'
import Kev from '../images/TestimonialSlider/lo-fly-dirt/kev-brown.png'
import Mic from '../images/TestimonialSlider/lo-fly-dirt/mic-checkmate.png'
import Michael from '../images/TestimonialSlider/lo-fly-dirt/michael-simpson.png'
import Oktober from '../images/TestimonialSlider/lo-fly-dirt/oktober1st.png'
import Samantha from '../images/TestimonialSlider/lo-fly-dirt/samantha-henry.png'
import Tone from '../images/TestimonialSlider/lo-fly-dirt/tone-jonez.png'
import V2 from '../images/TestimonialSlider/lo-fly-dirt/v2flawless.png'
import chevronleft from '../images/TestimonialSlider/chevron-left.svg'
import chevronright from '../images/TestimonialSlider/chevron-right.svg'
import quoteblue from '../images/TestimonialSlider/quote-blue.png'

const data = [
    {
        name: 'BILLy “VINTAGE” BLASS',
        quote: "Lo-Fly Dirt is another great addition to my MPC Standalone for me to add some grit and grime to my production on the go. It has a great selection of presets that bring life to your production whether in standalone mode or on desktop software.",
        title: 'Billy “Vintage” Blass, Producer and Beatmaker',
        featured: 'Chink Santana, Serius Jones, Lenny White, Jojo, Lil Eazy E',
        avatar: Billy,
    },
    {
        name: 'Samantha Henry',
        quote: "Lo-Fly Dirt helps me add just the right amount of character. I love to put it on vocals or even on the master during special moments to give a song character. There's no limit to how creative you can get with this plugin.",
        title: 'Samantha Henry, Engineer & Producer',
        featured: 'Tyga, YG, Asal',
        avatar: Samantha,
    },
    {
        name: 'Daniel Steele',
        quote: "Lo-Fly Dirt is the perfect tool for adding instant nostalgia to your track. It will transport you to the golden era of classic production techniques.",
        title: 'Daniel Steele, Producer & Musician',
        featured: "Andy Mineo, Social Club Misfits, H.E.R",
        avatar: Daniel,
    },
    {
        name: 'V2Flawless',
        quote: "This plugin effectively emulates the iconic tone of the SP1200, adding vibrant grit and harmonics to my bass drum. It delivers the contemporary Lo-Fi sound I was seeking, making it an essential tool for modern music production.",
        title: 'V2Flawless, Pop/Latin Producer, engineer',
        featured: "Tricky Stewart, Muni Long, BET Awards",
        avatar: V2,
    },
    {
        name: 'Mic Checkmate',
        quote: "Bringing Lo-Fly Dirt to the MPC hardware takes the plugin to a whole new level. I've used Lo Fly Dirt on my phone and iPad for years, but now I can dial in that 404 dust, MPC60 punch, or 404 Vinyl warmth with a hands-on feel on my MPC and DAW that brings a dope grit and character to my sound.",
        title: 'Mic Checkmate, Producer, Sound Designer & Educator',
        featured: "Slick Rick, Damian Lillard, Jidenna",
        avatar: Mic,
    },
    {
        name: 'DjCRISTAGURL',
        quote: "Lo-Fly Dirt is the difference between sounding made and sounding found. It brings raw and punchy excitement to my drum and bass production. My go to plugin when producing 80s and 90s music.",
        title: 'Dj CRISTAGURL, DJ, Producer & composer',
        featured: "",
        avatar: Crista,
    },
    {
        name: 'AG Got Beats',
        quote: "Lo-Fly Dirt inside my MPC Live 2 is mobile magic. One less thing I have to use my iPad for. LFD makes it easy to add just the right amount of vintage sauce to my modern production. Between the presets and the dry/wet knob in Lo-Fly Dirt, I have more than enough options to fine tune my sound.",
        title: 'AG Got Beats, Producer',
        featured: '',
        avatar: AG,
    },
    {
        name: 'Oktober1st',
        quote: "LFD on the touch screen of the MPC feels like a hardware unit that adds a feel similar to an effect pedal. From the lighter default MSXII mode to the heavy saturation models, each one has an instant tone, crunch & color. You can even try it on the master. The factory presets are perfect start or finish to any keys & drums.",
        title: 'Oktober1st, Producer',
        featured: "H.E.R, Jayson Lyric, Rick Ross",
        avatar: Oktober,
    },
    {
        name: 'Damon Flores',
        quote: "Lo-Fly Dirt doesn't just color your sound—it paints it with character, imperfections, and that sweet analog warmth. MSXII's Lo Fly Dirt is that secret sauce—one turn of the dial and your clean samples sound like dusty vinyl straight from the crates.",
        title: 'Damon Flores, Beat maker / Music Producer',
        featured: "Ren Thomas, Destruct, C-Red, MALCOLMSEF, Akai MPC Stems Campaign",
        avatar: Damon,
    },
    {
        name: 'Michael Simpson',
        quote: "Lo-Fly Dirt on the MPC is literally a dream come true. What LFD does for drums, bass, and other instruments is second to none. You'll instantly catch a vibe scrolling through the presets and that's the best thing about it. It simply works!.",
        title: 'Michael Simpson, founder & CEO of MSXII Sound Design',
        featured: "Partynextdoor, Bibi Bourelly, H.E.R. & Apollo Brown",
        avatar: Michael,
    },
    {
        name: 'Tone Jonez',
        quote: "Lo-Fly Dirt is THE cheat code for bringing out unique textures, especially on drums and subs. Having it on iOS was already a game changer but now having it on my MPC and on desktop VST is next level!",
        title: 'Tone Jonez, Producer',
        featured: 'Lecrae, Wale, Kirk Franklin',
        avatar: Tone,
    },
    {
        name: 'Donnel Mcgary',
        quote: "I've been in love with Lo-Fly Dirt Plug-In since it first hit iOS. The textures and the knock it adds to my mobile beats are game changer. And now, with its integration with the MPC Live 2, it's just next level.",
        title: 'Donell McGary, Producer & Engineer',
        featured: '',
        avatar: Donell,
    },
    {
        name: 'Kev Brown',
        quote: "I like the simple user interface. That's a definite plus. The presets are a big help also. One of my favorites is 'Cold Piece'. Lo Fly Dirt is very helpful with drums and sound design. Adding that missing authentic texture and feel/grit from the older beat machines.",
        title: 'Kev Brown, Producer & Beatmaker',
        featured: 'Kaimbr, J Scienide, Daru Jones',
        avatar: Kev,
    },
    {
        name: 'David Lopez',
        quote: "A clean, retro-feel interface and simple controls, LFD gives me everything I need and nothing more. All 7 Modes provide a wide range of sonic coloration and texture. It's quickly become a go-to tool in my plug-in arsenal.",
        title: 'Producer, Engineer & Content Creator',
        featured: '',
        avatar: David,
    }
]

function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <img src={chevronright} alt=''
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        />
    )
}

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <img src={chevronleft} alt=''
            className={className}
            style={{ ...style, display: "block", }}
            onClick={onClick}
        />
    )
}

export default function SimpleSlider() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 10000,
                settings: {
                    centerMode: true,
                    centerPadding: "200px",
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                    centerPadding: "0px",
                }
            },
        ]
    }

    return (
        <div className="slider-container container-fluid testimonial-slider py-5 px-0" style={{
            background: `url(${background2})`,
            backgroundSize: 'cover',
        }}>
            <div className="container pt-5 pb-3 px-0">
                <div className="row justify-content-center text-center">
                    <div className="col-xs-12">
                <h2
                    className="text-white text-uppercase text-center pt-3 changeling-neo"
                    style={{
                        fontSize: 48
                    }}
                >
                    what they're saying
                </h2>
                </div>
                </div>
            </div>
            <div className="container-fluid pb-5 px-0">
                <div className="pb-5">                
                <Slider {...settings}>
                    {data.map(({ name, quote, title, featured, avatar }) => {
                        return (
                            <div>
                                <div className="mx-5" style={{
                                    borderRadius: 8,
                                    background: `url(${background})`,
                                    boxShadow: `4px 4px 4px 0px rgba(0, 0, 0, 0.15)`,
                                }}>
                                    <div className="row text-white align-items-center">
                                        {/* LARGE SCREEN IMAGE LEFT */}
                                        <div className="col-auto d-none d-md-block position-relative">
                                            <img src={avatar} alt='' className="p-5 mw-100" />
                                            <img src={quoteblue} alt='' style={{
                                                position: 'absolute',
                                                bottom: 24,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                            }} />
                                        </div>

                                        {/* QUOTE TEXT */}
                                        <div className="col">
                                            <div className="p-3">
                                                <h4 className="text-uppercase mb-4" style={{ fontSize: 32 , color:'#8FE2F6' }}>{name}</h4>
                                                <p className="font-italic" style={{ fontSize: 18 }}>"{quote}"</p>
                                                <p className="bold mb-0" style={{ fontSize: 14 }}>{title}</p>
                                                <p className="mb-0" style={{ fontSize: 14 }}>{featured}</p>
                                            </div>
                                        </div>

                                        {/* IMAGE BELOW QUOTE ON SMALL SCREEN */}
                                        <div className="col-12 d-md-none position-relative text-center mb-3">
                                            <img src={avatar} alt='' className="p-3 d-inline-block mw-100" />
                                            <img src={quoteblue} alt='' style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </Slider>
                </div>
            </div>
        </div>
    )
}
